// PDFDocument.js
import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: { backgroundColor: "#fff", padding: 15 },
    headerSection: {
        marginBottom: 15,
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
    },
    header: { fontSize: 18, fontWeight: "bold", color: "#222" },
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        marginTop: 10,
    },
    tableRow: {
        flexDirection: "row",
    },
    tableColHeader: {
        width: "20%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        backgroundColor: "#eee",
        padding: 3,
    },
    tableCol: {
        width: "20%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 3,
    },
    tableCellHeader: { fontSize: 10, fontWeight: "bold", textAlign: "center" },
    tableCell: { fontSize: 10 },
    footerRow: {
        marginTop: 10,
        flexDirection: "row",
        justifyContent: "flex-end",
    },
    footerText: { fontSize: 12, fontWeight: "bold", textAlign: "right" },
    textLeft: { textAlign: "left" },
    textRight: { textAlign: "right" },
});

const formatDate = (dateInput) => {
    if (!dateInput) return "";
    const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
    if (isNaN(date.getTime())) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};

const PDFDocument = ({ data = [], totalSum = 0, profitSum = 0 }) => (
    <Document>
        <Page size="A4" style={styles.page}>
            <View style={styles.headerSection}>
                <Text style={styles.header}>Order List</Text>
            </View>

            <View style={styles.table}>
                <View style={styles.tableRow}>
                    {["Invoice No", "Invoice Date", "Customer", "Total", "Profit"].map((header, i) => (
                        <View key={i} style={styles.tableColHeader}>
                            <Text style={styles.tableCellHeader}>{header}</Text>
                        </View>
                    ))}
                </View>

                {data.map((item, idx) => (
                    <View style={styles.tableRow} key={item.InvoiceNo || idx}>
                        <View style={styles.tableCol}>
                            <Text style={[styles.tableCell, styles.textLeft]}>{item.InvoiceNo || "-"}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={[styles.tableCell, styles.textLeft]}>
                                {formatDate(item.InvoiceDate || item.DDate)}
                            </Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={[styles.tableCell, styles.textLeft]}>{item.Customer || "-"}</Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={[styles.tableCell, styles.textRight]}>
                                {typeof item.Total === "number" ? item.Total.toFixed(2) : "0.00"}
                            </Text>
                        </View>
                        <View style={styles.tableCol}>
                            <Text style={[styles.tableCell, styles.textRight]}>
                                {typeof item.Profit === "number" ? item.Profit.toFixed(2) : "0.00"}
                            </Text>
                        </View>
                    </View>
                ))}
            </View>

            <View style={styles.footerRow}>
                <Text style={[styles.footerText, styles.textRight]}>Total: {totalSum.toFixed(2)}</Text>
            </View>
            <View style={styles.footerRow}>
                <Text style={[styles.footerText, styles.textRight]}>Profit: {profitSum.toFixed(2)}</Text>
            </View>
        </Page>
    </Document>
);

export default PDFDocument;
